import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';

// MaterialUI
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import TextField from '@material-ui/core/TextField';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import CssSearchField from './SearchField.scss';

function SearchField(props) {
  const { label, onSubmit, inputProps, className, ...otherProps } = props;
  const isOnDesktop = useMediaQuery('(min-width: 641px)');

  const isOnCordovaPhone = useMemo(
    () => {
      if (typeof window === 'undefined') {
        return false;
      }

      return !isOnDesktop && window.cordova;
    },
    [isOnDesktop],
  );

  useStyles(CssSearchField);

  return (
    <TextField
      label={label}
      type="search"
      variant="outlined"
      className={`searchfield ${className} ${isOnCordovaPhone && 'set-label-line-height'}`}
      InputProps={{
        inputProps,
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon className="searchfield__magnifier" onClick={onSubmit} />
          </InputAdornment>
        ),
      }}
      {...otherProps}
    />
  );
}

SearchField.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  onSubmit: PropTypes.func,
  inputProps: PropTypes.shape({}),
};

SearchField.defaultProps = {
  label: 'Search',
  className: '',
  onSubmit: null,
  inputProps: {},
};

export default SearchField;
